<template>
  <v-layout column v-if="compradores.length > 0">
    <o-base-justify-text>
      <span v-html="getTexto('scoring.numInquilinos', codigoPromocion)"/>
    </o-base-justify-text>
    <v-form ref="form" v-model="valid">
      <slide-y-list group tag="div">
      <!-- <v-slide-y-transition group tag="div"> -->
        <v-card 
          class="comprador mt-4"
          v-for="(comprador, i) in compradores"
          :key="'comprador'+comprador.id_temporal"
        >
          <v-card-text class="px-4 pt-1">
            <o-medium-title-erase style="margin-bottom:16px; margin-top: 6px" :botonBorrar="compradores.length === 1 ? false : true" :borrar="borrar" @borrar="mostrarAvisoBorrar(i)">{{$t('reservas.scoring.datosArrendatario') + (i+1)}}</o-medium-title-erase>
            <FormularioCompradorScoring 
              :comprador.sync="comprador" 
              :loading="waitingForLoad" 
              :waitingForLoad="waitingForLoad"
              :indice="i"
            />
          </v-card-text>
        </v-card>
      <!-- </v-slide-y-transition> -->
      </slide-y-list>
    </v-form>
    <v-layout>
    <add-arrendatario :disabled="waitingForLoad" @addArrendatario="addComprador">{{$t('reservas.scoring.addArrendatario')}}</add-arrendatario>
    </v-layout>
    <v-fade-transition>
      <custom-dialog v-if="mostrarBorrar" v-model="mostrarBorrar">
        <KycBorrar
          :description="descripcionBorrar(indiceBorrar)"
          :titulo="$t('reservas.scoring.eliminarArrendatario')"
          @continuar="borrarComprador"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-layout justify-space-between align-center>
        <v-flex xs2>
        </v-flex>
        <v-layout 
          :column="$vuetify.breakpoint.smAndDown" 
          :shrink="$vuetify.breakpoint.smAndDown" 
          justify-space-around
        >
          <v-btn
            large
            color="primary"
            :disabled="waitingForLoad"
            :loading="waitingForLoad"
            @click="aceptar"
          >
            {{$t('reservas.scoring.continuar')}}
          </v-btn>
        </v-layout>
        <v-flex xs2/>
      </v-layout>
  </v-layout>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import FormularioCompradorScoring from '@/components/reservas/scoring/FormularioCompradorScoring'
import KycBorrar from '@/components/reservas/kyc/KycBorrar'
import MixinComprador from '@/mixins/comprador'
import rules from '@/mixins/rules'
import uniqid from 'uniqid'

export default {
  mixins: [rules, MixinComprador],
  props: {
    compradores: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      mostrarBorrar: false,
      indiceBorrar: -1,
      expansion: [],
      valid: false,
      waitingForLoad: false,
      borrar: ''
    }
  },
  created () {
    this.addComprador()
  },
  components: {
    FormularioCompradorScoring,
    KycBorrar
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario',
      inmuebles: 'promociones/inmuebles/getAll',
      promociones: 'promociones/getAll',
      tarifa: 'reservas/_id/tarifas/getActual',
      numOportunidad: 'incrustado/numOportunidad',
      reserva: 'reservas/_id/getActual',
      codigoPromocion: 'incrustado/codigoPromocion',
      codigoActivo: 'incrustado/codigoActivo'
    }),
    expansionComputed: {
      get () {
        return this.expansion
      },
      set (val) {
        val.forEach((x, index) => {
          this.$set(this.expansion, index, val[index])
        })
      }
    },
    ingresoCero () {
      return this.compradores.map(x => {
        return {...x}
      }).find(x => x.ingresos)
    },
    inmueble () {
      return this.inmuebles[0]
    },
    promocion () {
      return this.promociones[0]
    },
    totalImporte () {
      return this.tarifa.importeTotalConHijos
    },
    getRestoCompradores () {
      return this.compradores.filter((x, i) => i > 0)
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadInmueble: 'promociones/inmuebles/load',
      comprobarScoring: 'scoring/comprobarScoring'
    }),
    descripcionBorrar (indiceBorrar) {
      return this.$t('reservas.kyc.confirmacionEliminarArrendatario',
        {
          nombre: indiceBorrar + 1
        }
      )
    },
    async aceptar () {
      this.compradores.forEach(c => {
        c.gastos = c.gastos.filter(g => {
          return g.tipo != null || (g.valor != null && g.valor !== '')
        })
      })
      await this.$nextTick()
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t('general.misc.revisaCamposRojo'), color: 'error'})
        return
      }
      try {
        if (this.ingresoCero.ingresos.length < 1) {
          this.addAlert({texto: this.$t('reservas.scoring.relacionIngresos'), color: 'error'})
          return
        }
        this.waitingForLoad = true
        const objetoParaApi = {
          codigoPromocion: this.codigoPromocion,
          codigoActivo: this.codigoActivo,
          compradores: this.compradores,
          numOportunidad: this.numOportunidad
        }
        await this.comprobarScoring(objetoParaApi)
        this.$emit('terminado')
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    },
    mostrarAvisoBorrar (i) {
      this.indiceBorrar = i
      this.mostrarBorrar = true
    },
    borrarComprador () {
      this.mostrarBorrar = false
      this.compradores.splice(this.compradores.indexOf(this.compradores[this.indiceBorrar]), 1)
      this.indiceBorrar = -1
    },
    addComprador () {
      this.compradores.push({
        id_temporal: uniqid(),
        ingresos: [
          {
            concepto: null,
            tipo: null,
            valor: null,
            pagas: null,
            id_temporal: uniqid()
          }
        ],
        gastos: [
        ]
      })
    }
  }
}
</script>


<style lang="stylus" scoped>
  .v-expansion-panel__body > .v-card {
    box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)!important 
  }
    
  .removeArrendatario
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%);

  .textoAddArrendatario
    position: absolute
    left: 55px;
    top: 50%;
    transform: translateY(-50%);
    

  .btnAddArrendatario
    position: absolute;
    left: 5px;
    top: 50%;
    transform: translateY(-50%);

  .nuevoArrendatario
    border-style: dashed

  @media (max-width: 1200px)
    .buttonOtrosCompradores
      margin-top:0 !important

  @media (min-width: 1112px)
    .buttonOtrosCompradores
      margin-bottom:0 !important
      position: absolute 
      right: 10px
      top: 1%;
      

</style>



// WEBPACK FOOTER //
// src/components/reservas/scoring/BaseScoring.vue